module.exports = __webpack_public_path__ + "static/media/20-minutes.27d5f91d.png";